import { render, staticRenderFns } from "./IBS-metadata-widget.vue?vue&type=template&id=2b23166b"
import script from "./IBS-metadata-widget.vue?vue&type=script&lang=js"
export * from "./IBS-metadata-widget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports